/**
 * Which bucket a 整理範本 belongs to. Derived from the owner columns rather than
 * stored, so the presentation value cannot drift from access control.
 *
 * Listed nearest first: this is the order every template list shows the
 * buckets in, and the order a default takes effect in (one default per scope
 * may exist, and the nearer scope wins).
 */
export const NOTES_TEMPLATE_SCOPES = ['personal', 'organization', 'builtin'] as const
export type NotesTemplateScope = (typeof NOTES_TEMPLATE_SCOPES)[number]

/** The scopes a member may create a template in; built-ins are read-only to them. */
export const WRITABLE_NOTES_TEMPLATE_SCOPES = [
  'personal',
  'organization',
] as const satisfies readonly NotesTemplateScope[]
export type WritableNotesTemplateScope = (typeof WRITABLE_NOTES_TEMPLATE_SCOPES)[number]
